import React from 'react';

const StairsIcon = (props) => {
  return (
    <svg
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.9583 16.8786V11.6491H11.7288V6.41958H6.49868V1.19006H0V3.72889H3.95986V8.95841H9.18994V14.1879H14.4195V19.4175H19.649V23.3778H22.1878V16.8786H16.9583Z" fill="currentColor" />
      <path d="M14.5203 6.38532V8.92414H21.2728V2.17164H18.734V4.59008L14.1439 0L12.3486 1.79524L16.9387 6.38532H14.5203Z" fill="currentColor" />
    </svg>
  );
};

export default StairsIcon;
